import { inject, Injectable } from '@angular/core';

import { select, Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';

import { filterDefined } from '@core/common-legacy';
import { fetchIfNotLoaded } from '@core/ngrx-legacy';
import { TellentNavigationActions, TellentNavigationSelectors } from '@core/tellent-data';
import { injectTellentNavigationScope, TellentNavigationItem } from '@core/tellent-types';

// import { debugPrintDemoRouteMapping } from './navigation/debug-print-demo-route-mapping';

@Injectable({
  providedIn: 'root',
})
export class TellentNavigationDataFacade {
  #store = inject(Store);
  #scope = injectTellentNavigationScope();

  public navigationMain$: Observable<TellentNavigationItem[]> = this.#store.pipe(
    fetchIfNotLoaded(this.#store.select(TellentNavigationSelectors.selectMainNavMeta), () =>
      this.#store.dispatch(
        TellentNavigationActions.fetchMainNav({
          payload: {
            navScope: this.#scope,
          },
        }),
      ),
    ),
    select(TellentNavigationSelectors.selectMainNav),
    filterDefined,
    map(data => data.sections),
  );

  public navigationSettings$: Observable<TellentNavigationItem[]> = this.#store.pipe(
    fetchIfNotLoaded(this.#store.select(TellentNavigationSelectors.selectSettingsNavMeta), () =>
      this.#store.dispatch(
        TellentNavigationActions.fetchSettingsNav({
          payload: {
            navScope: ['admin', 'core_hr', 'grow', 'recruitment'],
          },
        }),
      ),
    ),
    select(TellentNavigationSelectors.selectSettingsNav),
    filterDefined,
    map(data => data.sections),
  );

  constructor() {
    // debugPrintDemoRouteMapping(this.navigationMain$, this.navigationSettings$);
  }

  public refreshMainNav() {
    this.#store.dispatch(
      TellentNavigationActions.fetchMainNav({
        payload: {
          navScope: this.#scope,
        },
      }),
    );
  }
}
